import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Mission from "@/components/Mission";
import Features from "@/components/Features";
import WhoIsItFor from "@/components/WhoIsItFor";
import Vision from "@/components/Vision";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/toaster";
import { useReveal } from "@/hooks/useReveal";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Privacidade from "@/pages/Privacidade";
import Termos from "@/pages/Termos";

const Home = () => {
  useReveal();
  return (
    <div className="bg-[#F4F4F2]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Mission />
        <Features />
        <WhoIsItFor />
        <Vision />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/termos" element={<Termos />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster />
      </LanguageProvider>
    </div>
  );
}

export default App;
